import feminine from 'assets/images/gender/feminine.svg'
import masculine from 'assets/images/gender/masculine.svg'
import neutral from 'assets/images/gender/neutral.svg'

const genderImages = {
  M: masculine.src,
  F: feminine.src,
  N: neutral.src,
}

export default genderImages
